import React from "react";

export default function Status({ status }) {
  const getBadgeClass = () => {
    switch (status) {
      case "PRE-REG":
      case "CLIENT":
        return "badge light border-0 badge-primary";
      case "LIVE":
        return "badge light border-0 badge-success";
      case "ARCHIVED":
        return "badge light border-0 badge-info";
      default:
        return "badge light border-0 badge-warning";
    }
  };

  return <span className={getBadgeClass()}>{status}</span>;
}
